export default __webpack_public_path__ + "static/media/Drawing Register.6a9d024f.svg";